import { useSelector } from "react-redux";
import Cart from "./components/Cart";
import Navbar from "./components/Navbar";
import Product from "./components/Product";
import "./styles/output.css";

function App() {
  const { page } = useSelector((state) => state.route);

  return (
    <>
      <Navbar />
      <main className="py-16">
        {page ? <Product /> : <Cart />}
      </main>
    </>
  );
}

export default App;
